import {
  CircularProgress,
} from '@mui/material';
import './PdfContainer.scss';
import NoLessonPaper from '../../../../../components/paper/NoLessonPaper';
import { useCheckPdf } from '../../../../hooks/CheckPdfLinkHooks';
import { filterUndefined } from '../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  pdfKey: null,
  loadingMessage: null,
  noPdfFoundMessage: 'No pdf found.',
  className: '',
};

const PdfContainer = (p) => {
  const {
    pdfKey,
    loadingMessage,
    noPdfFoundMessage,
    className,
  } = { ...defaultProps, ...filterUndefined(p) };
  const {
    loading,
    signedPdfUrl,
  } = useCheckPdf(pdfKey);

  if (loading) {
    return (
      <div className='pdf-container-loading'>
        <CircularProgress size={40} />
        <div className='loading-message'>
          {loadingMessage}
        </div>
      </div>
    );
  }

  if (!signedPdfUrl) {
    return (
      <NoLessonPaper message={noPdfFoundMessage} />
    );
  }

  return (
    <object className={`pdf-container ${className}`} data={signedPdfUrl} type='application/pdf'>
      <iframe title='Guide PDF' src={signedPdfUrl} />
    </object>
  );
};

export default PdfContainer;
